"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportViewMetricType = exports.ReportViewMetricUserPOV = exports.NonCustomReportViewName = exports.ReportViewMetric = void 0;
var ReportViewMetric;
(function (ReportViewMetric) {
    ReportViewMetric["UniqueVisitors"] = "unique_visitors";
    ReportViewMetric["UniqueConversions"] = "unique_conversions";
    ReportViewMetric["VisitorsConversionRate"] = "visitors_conversion_rate";
    ReportViewMetric["PageViewVisitorsConversionRate"] = "page_view_visitors_conversion_rate";
    ReportViewMetric["SessionsConversionRate"] = "sessions_conversion_rate";
    ReportViewMetric["PageViewSessionsConversionRate"] = "page_view_sessions_conversion_rate";
    ReportViewMetric["VisitorsGrowth"] = "visitors_growth";
    ReportViewMetric["RevisitRateVisitorsGrowth"] = "revisit_rate_visitors_growth";
    ReportViewMetric["SessionsGrowth"] = "sessions_growth";
    ReportViewMetric["BounceRateSessionsGrowth"] = "bounce_rate_sessions_growth";
    ReportViewMetric["NumberOfPagesViewedSessionsGrowth"] = "number_of_pages_viewed_sessions_growth";
    ReportViewMetric["Sessions"] = "sessions";
    ReportViewMetric["VisitorsConfidenceInterval"] = "visitors_confidence_interval";
    ReportViewMetric["SessionsConfidenceInterval"] = "sessions_confidence_interval";
    ReportViewMetric["VisitorsOpportunities"] = "visitors_opportunities";
    ReportViewMetric["SessionsOpportunities"] = "sessions_opportunities";
    ReportViewMetric["TotalConversions"] = "total_conversions";
    ReportViewMetric["TotalPageViewed"] = "total_page_viewed";
    ReportViewMetric["UniquePageViewed"] = "unique_page_viewed";
    ReportViewMetric["TransactionRate"] = "transaction_rate";
    ReportViewMetric["AverageOrderValue"] = "average_order_value";
    ReportViewMetric["Revenue"] = "revenue";
    ReportViewMetric["RevenuePerUser"] = "revenue_per_user";
    ReportViewMetric["UniqueTransactions"] = "unique_transactions";
    ReportViewMetric["TotalTransactions"] = "total_transactions";
    ReportViewMetric["TransactionRateGrowth"] = "transaction_rate_growth";
    ReportViewMetric["TransactionRateConfidenceInterval"] = "transaction_rate_confidence_interval";
    ReportViewMetric["AverageOrderValueGrowth"] = "average_order_value_growth";
    ReportViewMetric["AverageProductQuantity"] = "average_product_quantity";
    ReportViewMetric["AverageProductPrice"] = "average_product_price";
    ReportViewMetric["RevenueUplift"] = "revenue_uplift";
    ReportViewMetric["PotentialRevenueUplift"] = "potential_revenue_uplift";
    ReportViewMetric["TransactionRateOpportunities"] = "transaction_rate_opportunities";
    ReportViewMetric["BounceRate"] = "bounce_rate";
    ReportViewMetric["NumberOfPagesViewed"] = "number_of_pages_viewed";
    ReportViewMetric["NumberOfRevisits"] = "number_of_revisits";
    ReportViewMetric["RevisitRate"] = "revisit_rate";
    ReportViewMetric["VisitorsConversionGain"] = "visitors_conversion_gain";
    ReportViewMetric["VisitorsTransactionGain"] = "visitors_transaction_gain";
    ReportViewMetric["VisitorsAudienceSize"] = "visitors_audience_size";
    ReportViewMetric["SessionsAudienceSize"] = "sessions_audience_size";
    ReportViewMetric["AverageOrderValueProbability"] = "average_order_value_probability";
    ReportViewMetric["VisitorsProbability"] = "visitors_probability";
    ReportViewMetric["RevisitRateVisitorsProbability"] = "revisit_rate_visitors_probability";
    ReportViewMetric["PageViewVisitorsProbability"] = "page_view_visitors_probability";
    ReportViewMetric["SessionsProbability"] = "sessions_probability";
    ReportViewMetric["VisitorsOpportunitiesProbability"] = "visitors_opportunities_probability";
    ReportViewMetric["RevisitRateVisitorsOpportunitiesProbability"] = "revisit_rate_visitors_opportunities_probability";
    ReportViewMetric["SessionsOpportunitiesProbability"] = "sessions_opportunities_probability";
    ReportViewMetric["TransactionRateProbability"] = "transaction_rate_probability";
    ReportViewMetric["TransactionRateOpportunitiesProbability"] = "transaction_rate_opportunities_probability";
})(ReportViewMetric = exports.ReportViewMetric || (exports.ReportViewMetric = {}));
var NonCustomReportViewName;
(function (NonCustomReportViewName) {
    NonCustomReportViewName["RawData"] = "Raw data";
    NonCustomReportViewName["RawDataVisitors"] = "Raw data (visitors)";
    NonCustomReportViewName["RawDataSessions"] = "Raw data (sessions)";
    NonCustomReportViewName["Statistics"] = "Statistics";
    NonCustomReportViewName["Opportunities"] = "Opportunities";
    NonCustomReportViewName["Overview"] = "Overview";
    NonCustomReportViewName["TransactionStats"] = "Transaction stats";
    NonCustomReportViewName["AverageOrderValueStats"] = "Average order value stats";
    NonCustomReportViewName["RevenueData"] = "Revenue data";
})(NonCustomReportViewName = exports.NonCustomReportViewName || (exports.NonCustomReportViewName = {}));
var ReportViewMetricUserPOV;
(function (ReportViewMetricUserPOV) {
    ReportViewMetricUserPOV["Visitors"] = "visitors";
    ReportViewMetricUserPOV["Sessions"] = "sessions";
})(ReportViewMetricUserPOV = exports.ReportViewMetricUserPOV || (exports.ReportViewMetricUserPOV = {}));
var ReportViewMetricType;
(function (ReportViewMetricType) {
    ReportViewMetricType["Metric"] = "metric";
    ReportViewMetricType["Statistic"] = "statistic";
    ReportViewMetricType["RelativeMetric"] = "relative_metric";
})(ReportViewMetricType = exports.ReportViewMetricType || (exports.ReportViewMetricType = {}));
//# sourceMappingURL=types.js.map